export default __webpack_public_path__ + "static/media/background-image.14380adc.svg";